// Formato compartido de las piezas de Outbound Loads.
//
// Las cantidades y pesos reexportan los formateadores de Pedidos de venta:
// mismo criterio de hueco (`null` → «—», cero → «0» en cantidades pero no en
// pesos) y mismo texto, porque son la MISMA magnitud vista desde otra pantalla.
// Lo propio de aquí es la fecha de banda y el retraso, que no existen en
// Pedidos de venta porque esa pantalla no agrupa por proximidad a hoy.
export { fmtQty, fmtPeso, fmtCajas, fmtDate } from '@/components/pedidos-ventas/formato'

const MESES = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']

/** Día y mes cortos, en mayúsculas: «22 SEP». */
export function fmtDiaCorto(d: Date): string {
  return `${d.getDate()} ${MESES[d.getMonth()]}`
}

/**
 * Rótulo del rango de una banda de fecha.
 *
 * Mismo mes: «22–25 SEP». Meses distintos: «29 SEP–3 OCT», con el día y el mes
 * de cada extremo para que el cambio de mes no se lea como un error de resta.
 */
export function fmtRangoBanda(desde: Date, hasta: Date): string {
  if (desde.getTime() === hasta.getTime()) return fmtDiaCorto(desde)
  if (desde.getMonth() === hasta.getMonth() && desde.getFullYear() === hasta.getFullYear()) {
    return `${desde.getDate()}–${hasta.getDate()} ${MESES[desde.getMonth()]}`
  }
  return `${fmtDiaCorto(desde)}–${fmtDiaCorto(hasta)}`
}

/** Fecha corta dd/mm, para la 1ª línea de la celda de fecha de salida. */
export function fmtFechaCorta(d: Date): string {
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
}

/** Instante ISO con zona → «02/11/2026 10:30» en hora LOCAL del navegador.
 *  `null`/ilegible → «—». Las fechas de transporte y de aviso son instantes, no
 *  días de calendario como la fecha de salida, y por eso no pasan por `fmtDate`. */
export function fmtFechaHora(iso?: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  const dos = (n: number) => String(n).padStart(2, '0')
  return `${dos(d.getDate())}/${dos(d.getMonth() + 1)}/${d.getFullYear()} ${dos(d.getHours())}:${dos(d.getMinutes())}`
}
